export default function About() {
  return (
    <div data-testid="about-page" className="px-6 md:px-12 lg:px-20 py-20 md:py-28">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-20">
        <div className="md:col-span-7">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#71717A] mb-6">
            About the studio
          </p>
          <h1 className="font-display font-black text-6xl md:text-8xl leading-[0.85] tracking-tighter">
            Printed in
            <br />
            Cornwall<span className="text-[#FFD600]">.</span>
          </h1>
        </div>
        <div className="md:col-span-5 self-end">
          <p className="font-mono text-base leading-relaxed text-[#27272A]">
            Xemi is a fresh, independent print studio based on
            the south coast of Cornwall — running a full DTF press and a
            dye-sublimation press to put colour into fabric for the UK's
            brands, makers and dreamers.
          </p>
        </div>
      </div>

      {/* Workshop image */}
      <div className="relative w-full aspect-[16/8] mb-20 overflow-hidden border border-black/10">
        <img
          src="https://images.pexels.com/photos/27893067/pexels-photo-27893067.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Workshop"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Story 2-col */}
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-24">
        <div className="md:col-span-5">
          <h2 className="font-display font-black text-4xl md:text-5xl leading-[0.95]">
            New press,
            <br />
            old craft —
            <br />
            <span className="text-[#E6007A]">born in 2025.</span>
          </h2>
        </div>
        <div className="md:col-span-7 space-y-6 font-mono text-base leading-relaxed text-[#27272A]">
          <p>
            Xemi launched in 2025 with a simple idea: bring a proper, modern
            DTF and sublimation setup to Cornwall and make custom apparel
            printing feel personal again — no faceless print farms, no
            minimum orders, no chasing answers across time zones.
          </p>
          <p>
            Every transfer is colour-matched, heat-pressed and
            quality-checked before it leaves the studio. We obsess over wash
            resistance, colour accuracy and the soft-hand feel that screen
            printers swear DTF can't match. We disagree.
          </p>
          <p>
            We don't outsource. We don't hide minimums. And we'll happily
            print a single piece for you if that's what you need to test an
            idea before going bigger.
          </p>
        </div>
      </div>

      {/* Numbers */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-black/10 border border-black/10">
        {[
          ["2025", "Founded"],
          ["UK", "Shipping nationwide"],
          ["1", "Piece minimum"],
          ["DTF + Sub", "100% in-house"],
        ].map(([n, l]) => (
          <div key={l} className="bg-white p-8">
            <p className="font-display font-black text-5xl md:text-6xl leading-none mb-3">{n}</p>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#71717A]">{l}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
